import React, { useEffect, useState } from "react";
import client from "@culturehq/client";
import { Button, Icon, Loader, Panel } from "@culturehq/components";
import { getSearchValue, Trans } from "app/utils";
import { getUnsplashRandomImage } from "app/utils/unsplash";
import { useFetch } from "app/hooks";

import ErrorBoundary from "components/common/ErrorBoundary";
import { Link } from "react-router-dom";
import { useProfile } from "app/context";
import hasCustomImageLibrary from "app/utils/hasCustomImageLibrary";
import getCustomImageLibrary from "./post-stories-v2/common/PostStoryForm/custom-image-library/getCustomImageLibrary";

const StoryImage = ({ preFilledQuestion }) => {
  const [image, setImage] = useState(undefined);
  const [searchValue] = useState(getSearchValue(preFilledQuestion));
  const { profile: { organization: { name: orgName } } } = useProfile();
  const hasLibrary = hasCustomImageLibrary(orgName);

  useEffect(
    () => {
      let isMounted = true;

      const getRandomImage = async tag => {
        if (hasLibrary) {
          const images = getCustomImageLibrary(orgName);
          const max = images.length - 1;
          const randomNum = Math.floor(Math.random() * (max)) + 1;
          const result = { urls: { thumb: images[randomNum].urls.regular } };
          if (isMounted) setImage(result);
        } else {
          const result = await getUnsplashRandomImage(tag);
          if (isMounted) setImage(result);
        }
      };

      if (preFilledQuestion?.imageUrl) {
        setImage({ urls: { thumb: preFilledQuestion.imageUrl } });
      } else {
        getRandomImage(searchValue);
      }

      return () => {
        isMounted = false;
      };
    },
    [hasLibrary, orgName, preFilledQuestion, searchValue]
  );

  return (
    <Loader loading={!image}>
      <div
        className="Story--Image"
        style={{ backgroundImage: `url(${image?.urls?.thumb})` }}
      />
    </Loader>
  );
};

const StartTheTrend = ({ title = "Start the trend!", icon = "thunder", currentStoryId }) => {
  const { fetching, json: { storyQuestions = [] } } = useFetch(
    () => client.getStoryQuestions({ unanswered: true }),
    []
  );
  if (storyQuestions.length === 1) return <></>;

  return (
    <>
      {storyQuestions.length > 0 && (
        <div className="Start-The-Trend">
          <Panel>
            <Panel.Heading>
              <Icon icon={icon} />
              <Trans>{title}</Trans>
            </Panel.Heading>
            <Panel.Body>
              <Loader loading={fetching}>
                <ErrorBoundary>
                  {storyQuestions.map(story => (
                    <div key={story.id}>
                      {(currentStoryId !== story.id) && (
                        <div key={story.id} className="Story--Link">
                          <StoryImage preFilledQuestion={story} />
                          <div className="Story--Texts">
                            <span className="Story--Question">{story.question}</span>
                          </div>
                          <Link to={`/stories/trend/${story.id}#create`} key={story.id} className="Story--Share">
                            <Button inverted>
                              View
                            </Button>
                          </Link>
                        </div>
                      )}
                    </div>
                  ))}
                </ErrorBoundary>
              </Loader>
            </Panel.Body>
          </Panel>
        </div>
      )}
    </>
  );
};

export default StartTheTrend;
